module.exports = __webpack_public_path__ + "static/media/IELTS-AcademicReading-DragDrop2.5ec3b5db.png";